<nb-card
  class="tw-w-[95vw] lg:tw-w-auto tw-mx-auto tw-flex tw-max-h-[90vh] tw-flex-col tw-rounded-xl tw-border tw-border-gray-200 tw-bg-white tw-shadow-lg"
>
  <nb-card-header class="tw-border-b tw-border-gray-200 tw-px-6 tw-py-4">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-4">
      <span class="tw-text-lg tw-font-semibold tw-text-gray-900">{{ headerTitle }}</span>
      <button class="tw-min-w-0 tw-shrink-0 tw-text-gray-400 hover:tw-text-gray-600" (click)="close()" aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
          <g clip-path="url(#clip0_42363_23646)">
            <path
              d="M7.20988 6L11.7388 1.47109C11.8205 1.39216 11.8857 1.29775 11.9305 1.19336C11.9754 1.08896 11.999 0.976687 12 0.863076C12.001 0.749464 11.9793 0.636794 11.9363 0.531639C11.8933 0.426484 11.8297 0.33095 11.7494 0.250611C11.669 0.170273 11.5735 0.106739 11.4684 0.0637164C11.3632 0.020694 11.2505 -0.000954946 11.1369 3.23065e-05C11.0233 0.00101956 10.911 0.0246235 10.8066 0.0694668C10.7023 0.11431 10.6078 0.179495 10.5289 0.261217L6 4.79012L1.47109 0.261217C1.30972 0.105355 1.09358 0.0191112 0.869234 0.0210607C0.644888 0.0230102 0.430283 0.112997 0.27164 0.27164C0.112997 0.430283 0.0230102 0.644888 0.0210607 0.869234C0.0191112 1.09358 0.105355 1.30972 0.261217 1.47109L4.79012 6L0.261217 10.5289C0.179495 10.6078 0.11431 10.7023 0.0694668 10.8066C0.0246235 10.911 0.00101956 11.0233 3.23065e-05 11.1369C-0.000954946 11.2505 0.020694 11.3632 0.0637164 11.4684C0.106739 11.5735 0.170273 11.669 0.250611 11.7494C0.33095 11.8297 0.426484 11.8933 0.531639 11.9363C0.636794 11.9793 0.749464 12.001 0.863076 12C0.976687 11.999 1.08896 11.9754 1.19336 11.9305C1.29775 11.8857 1.39216 11.8205 1.47109 11.7388L6 7.20988L10.5289 11.7388C10.6903 11.8946 10.9064 11.9809 11.1308 11.9789C11.3551 11.977 11.5697 11.887 11.7284 11.7284C11.887 11.5697 11.977 11.3551 11.9789 11.1308C11.9809 10.9064 11.8946 10.6903 11.7388 10.5289L7.20988 6Z"
              fill="#9CA3AF"
            />
          </g>
          <defs>
            <clipPath id="clip0_42363_23646">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body class="tw-min-h-0 tw-flex-1 tw-p-0" [class.tw-overflow-auto]="step === 'topup'">
    <!-- Channel -->
    <div *ngIf="step === 'channel'" class="tw-p-6">
      <ngx-notification-channel-picker [channels]="channels" [selectedChannel]="selectedChannel" (channelSelect)="selectChannel($event)" />
    </div>

    <!-- Cost (matches confirmation mock: intro, bullets, prompt) -->
    <div *ngIf="step === 'cost' && selectedChannel !== null" class="tw-p-6 tw-flex tw-flex-col tw-gap-3">
      <p class="tw-text-base tw-leading-relaxed tw-text-gray-700">
        {{ resendConfirmationIntroMessage(selectedChannel, attendeeCount) }}
      </p>
      <ul class="tw-list-disc tw-space-y-2 tw-pl-5 tw-text-base tw-leading-relaxed tw-text-gray-700 marker:tw-text-gray-700">
        <li class="tw-mb-3 tw-font-bold">
          <span class="tw-text-gray-900">{{ costPerLabel(selectedChannel) }}:</span>
          {{ unitPrice(selectedChannel) | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}
        </li>
        <li class="tw-font-bold">
          <span class="tw-text-gray-900">Total cost:</span>
          {{ totalPrice() | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}
          ({{ attendeeCount }} × {{ unitPrice(selectedChannel) | currency : 'USD' : 'symbol-narrow' : '1.2-2' }})
        </li>
      </ul>

      <div class="tw-flex tw-min-h-11 tw-items-center">
        @if (loadingBalance) {
        <p class="tw-m-0 tw-text-base tw-leading-relaxed tw-text-gray-500">Checking wallet balance…</p>
        } @else if (insufficientBalance) {
        <div class="tw-w-full tw-rounded-lg tw-border tw-border-amber-200 tw-bg-amber-50 tw-px-2 tw-py-3 tw-text-center">
          <div class="tw-flex tw-items-center tw-justify-center tw-gap-2">
            <svg class="tw-shrink-0" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path
                d="M2.99882 19H16.9921C19.295 19 20.7426 16.5 19.6021 14.5435L12.5835 2.5C11.443 0.5 8.54787 0.5 7.40735 2.5L0.388796 14.5435C-0.729787 16.5217 0.695858 19 2.99882 19ZM10.0174 16.3261C9.40326 16.3261 8.8988 15.8261 8.8988 15.2174C8.8988 14.6087 9.40326 14.1087 10.0174 14.1087C10.6315 14.1087 11.136 14.6087 11.114 15.2391C11.136 15.8261 10.6096 16.3261 10.0174 16.3261ZM9.73225 6.32609C10.2586 6.19565 10.807 6.45652 11.0263 6.95652C11.0921 7.13043 11.136 7.30435 11.136 7.5C11.114 8.04348 11.0702 8.6087 11.0263 9.15217C10.9824 10 10.9166 10.8696 10.8728 11.7174C10.8508 12 10.8508 12.2391 10.8508 12.5217C10.8289 12.9783 10.478 13.3261 10.0174 13.3261C9.55679 13.3261 9.20586 13 9.18393 12.5435C9.11813 11.2174 9.0304 9.8913 8.9646 8.56522C8.94266 8.21739 8.92073 7.86957 8.8988 7.5C8.87686 6.95652 9.20586 6.47826 9.73225 6.32609Z"
                fill="#E3A008"
              />
            </svg>
            <p class="tw-m-0 tw-text-sm tw-leading-5 tw-text-gray-700">
              <span class="tw-font-medium">Insufficient balance. </span>
              <span class="tw-font-normal">Please add </span>
              <span class="tw-font-semibold">{{ balanceShortfallUsd() | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}</span>
              <span class="tw-font-normal"> to resend confirmations.</span>
            </p>
          </div>
        </div>
        } @else if (balanceChecked) {
        <p class="tw-m-0 tw-text-base tw-font-normal tw-leading-relaxed tw-text-gray-700">Do you want to proceed?</p>
        }
      </div>
    </div>

    <!-- Top up (inline step) -->
    @if (step === 'topup') {
    <app-billing-wallet-top-up-modal
      [embedded]="true"
      [active]="true"
      [initialCustomAmount]="suggestedTopUpAmount()"
      [paymentMethods]="paymentMethods()"
      (topUpSuccess)="onWalletTopUpSuccess($event)"
      (cancelRequested)="backFromTopUp()"
    ></app-billing-wallet-top-up-modal>
    }
  </nb-card-body>

  @if (step === 'cost' && selectedChannel !== null) {
  <nb-card-footer class="tw-shrink-0 tw-border-t tw-border-gray-200 tw-px-6 tw-py-4">
    <div class="tw-flex tw-w-full tw-items-stretch tw-justify-between tw-gap-4 sm:tw-items-center">
      <button
        type="button"
        class="tw-rounded-md tw-border tw-border-gray-300 tw-bg-white tw-px-5 tw-py-2.5 tw-font-medium tw-text-gray-800 tw-shadow-none hover:tw-bg-gray-50 disabled:tw-opacity-50"
        (click)="backToChannels()"
        [disabled]="sending || loadingBalance || loadingPaymentMethods"
      >
        Back
      </button>
      <button
        type="button"
        class="tw-rounded-md tw-border-0 !tw-bg-blue-600 tw-px-5 tw-py-2.5 tw-font-medium !tw-text-white tw-shadow-none hover:!tw-bg-blue-700 focus:tw-ring-2 focus:tw-ring-blue-500 focus:tw-ring-offset-2 disabled:tw-opacity-50"
        (click)="onConfirmSend()"
        [disabled]="sending || loadingBalance || loadingPaymentMethods || (!balanceChecked && !insufficientBalance)"
      >
        {{ confirmSendButtonLabel() }}
      </button>
    </div>
  </nb-card-footer>
  }
</nb-card>
